"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { useAuth } from "@/lib/auth";
import { ApiException } from "@/lib/api";
import { Button, Card, ErrorText, TextField } from "@/components/ui";

export default function LoginPage() {
  const router = useRouter();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(email, password);
      router.push("/dashboard");
    } catch (err) {
      setError(err instanceof ApiException ? err.message : "로그인에 실패했습니다.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="flex flex-1 items-center justify-center p-8">
      <Card radius="lg" elevation="lg" className="w-full max-w-md p-10">
        <p className="text-sm font-medium tracking-wide text-primary">ONCARE ADMIN</p>
        <h1
          className="mt-2 text-[22px] font-bold text-ink"
          style={{ fontFamily: "var(--font-gowun-batang)" }}
        >
          관리자 로그인
        </h1>
        <p className="mt-1 text-sm text-muted">최고관리자 콘솔에 로그인합니다.</p>

        <form onSubmit={onSubmit} className="mt-8 flex flex-col gap-4">
          <TextField
            label="이메일"
            type="email"
            required
            autoComplete="username"
            placeholder="name@oncare.kr"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            label="비밀번호"
            type="password"
            required
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <ErrorText>{error}</ErrorText>

          <Button type="submit" className="mt-2" disabled={submitting}>
            {submitting ? "로그인 중…" : "로그인"}
          </Button>
        </form>
      </Card>
    </main>
  );
}
